import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsMainComponent } from './settings-main.component';
import { PromptCodesComponent } from './prompt-codes/prompt-codes.component';
import { PromptSchedulesComponent } from './prompt-schedules/prompt-schedules.component';
import { MaintananceCriteriasComponent } from './maintanance-criterias/maintanance-criterias.component';
import { MasteryCriteriaComponent } from './mastery-criteria/mastery-criteria.component';
import { ProbeCriteriaComponent } from './probe-criteria/probe-criteria.component';
import { SettingsAuthGuard } from '../core/settings-auth.guard';
const routes: Routes = [
  
  { path: 'settings', component: SettingsMainComponent, canActivate: [SettingsAuthGuard], children: [
    { path: 'prompt-codes', component: PromptCodesComponent, canActivate: [SettingsAuthGuard] },
    { path: 'prompt-schedules', component: PromptSchedulesComponent, canActivate: [SettingsAuthGuard] },
    { path: 'maintanance-criteria', component: MaintananceCriteriasComponent, canActivate: [SettingsAuthGuard] },
    { path: 'mastery-criteria', component: MasteryCriteriaComponent, canActivate: [SettingsAuthGuard] },
    { path: 'probe-criteria', component: ProbeCriteriaComponent, canActivate: [SettingsAuthGuard] },
  ] },
];

@NgModule({
    imports: [
      RouterModule.forRoot(routes, {
        bindToComponentInputs: true,
        paramsInheritanceStrategy: 'always',
      }),
    ],
    exports: [RouterModule],
  })
  export class SettingsRoutingModule {}